export default __webpack_public_path__ + "static/media/ic-instruction-09.5f716370.svg";